import {
  setChildInfoStatus,
  setChildInfoData,
  removeChildMedia,
} from "./stateChildData";
import {
  setCommunityInfoData,
  setCommunityInfoStatus,
} from "./stateCommunityData";
import {
  setListCommitmentsData,
  setListCommitmentsStatus,
} from "./stateCommitmentData";
import {
  setCommunityNewsData,
  setCommunityNewsStatus,
} from "./stateCommunityNews";
import {
  setCountryData,
  setCountryStatus,
} from "./stateCountryData";
import { setAppStatus, setAppError } from "./stateApp";
import { setCommitmentData, setCommitmentStatus } from "./stateCommitment";
import { setExpandoStatus } from "./expandoStatus";
import { setFeedsData, setFeedsStatus, setCategory, setFeedCategories } from "./stateFeeds";

export const reducer = (state, action) => {
  switch (action.type) {
    case "setAppStatus":
      return setAppStatus(state, action.payload);
    case "setAppError":
      return setAppError(state, action.payload);
    case "setChildInfoData":
      return setChildInfoData(state, action.payload);
    case "setChildInfoStatus":
      return setChildInfoStatus(state, action.payload);
    case "removeChildMedia":
      return removeChildMedia(state);
    case "setCommunityInfoData":
      return setCommunityInfoData(state, action.payload);
    case "setCommunityInfoStatus":
      return setCommunityInfoStatus(state, action.payload);
    case "setCommunityNewsData":
      return setCommunityNewsData(state, action.payload);
    case "setCommunityNewsStatus":
      return setCommunityNewsStatus(state, action.payload);
    case "setCountryData":
      return setCountryData(state, action.payload);
    case "setCountryStatus":
      return setCountryStatus(state, action.payload);
    case "setListCommitmentsData":
      return setListCommitmentsData(state, action.payload);
    case "setListCommitmentsStatus":
      return setListCommitmentsStatus(state, action.payload);
    case "setCommitmentData":
      return setCommitmentData(state, action.payload);
    case "setCommitmentStatus":
      return setCommitmentStatus(state, action.payload);
    case "setExpandoStatus":
      return setExpandoStatus(state, action.payload);
    case "setFeedsData":
      return setFeedsData(state, action.payload);
    case "setFeedsStatus":
      return setFeedsStatus(state, action.payload);
    case "setCategory":
      return setCategory(state, action.payload );
    case "setFeedCategories":
      return setFeedCategories(state, action.payload);
    default:
      return state;
  }
};

export default reducer;
